import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects'

import Api from '../../Api'
import mixpanel from 'mixpanel-browser';
import { push } from 'connected-react-router'

export const types = {
    FETCH_DASHBOARD: 'APPLICATIONS/FETCH_DASHBOARD',
    LOAD_DASHBOARD_DATA: 'APPLICATIONS/LOAD_DASHBOARD_DATA',
    REMOVE_COMPONENT: 'APPLICATIONS/REMOVE_COMPONENT',
    TOGGLE_BLOCK_ATTACKS: 'APPLICATIONS/TOGGLE_BLOCK_ATTACKS',
    LOG_OUT: 'APPLICATIONS/LOG_OUT',
}

export const actions = {
    fetchDashboard: (id) => ({ type: types.FETCH_DASHBOARD, id }),
    loadDashboardData: (data) => ({ type: types.LOAD_DASHBOARD_DATA, data }),
    toggleBlockAttacks: () => ({ type: types.TOGGLE_BLOCK_ATTACKS }),
    logout: () => ({ type: types.LOG_OUT }),
}

// roles: ['CustomerService', 'TechnicalSupport', 'Admin']

export const initialState = {
    applicationId: undefined,
    applicationName: '',
    components: [],
    componentsID: {},
    blockAttacks: false,
    availableIps: 0,
    under_maintenance: false,
    expiredAppsCount:0,
}

const dashboard = (state = initialState, action) => {
    switch (action.type) {
        case types.LOAD_DASHBOARD_DATA:
            return {
                ...state,
                availableIps: action.data.availableIps,
                under_maintenance: action.data.under_maintenance,
                username: action.data.username,
                groups: action.data.groups,
                expiredAppsCount: action.data.expired_apps_count
            }
        case types.REMOVE_COMPONENT: {            
            return {
                ...state,
                components: state.components.filter( c => c.id !== action.cid)                
            }
        }
        case types.TOGGLE_BLOCK_ATTACKS:
            return {
                ...state,
                blockAttacks: !state.blockAttacks
            }
        default:
            return state;
    }
}

export default dashboard;

export function* fetchApplicationData(action) {
    try {
        const data = yield call(Api.fetchAppData, action.id);
        yield put(actions.loadDashboardData(data));
    }
    catch (e) {
    }
}

export function* toggleBlockAttacks(action) {
    try {
        const store = yield select();
        const state = store.waas.applications
        yield call(Api.updateAppMode, state.applicationId, { protection_mode: state.blockAttacks ? 'Active' : 'Passive' })
        const data = yield call(Api.fetchAppData, state.applicationId);

        // MIXPANEL
        mixpanel.track('BlockAttacksToggled', {
            From: 'Applications',
            NewState: state.blockAttacks ? 'Yes' : 'No',
            AppId: state.applicationId
        });

        yield put(actions.loadDashboardData(data));
    }
    catch (e) {
    }
}

export function* logout(action) {
    try {
        yield call(Api.logout);
        yield put(push('/403'));
    } catch (e) {
    }
}

export function* fetchDashboard(action) {
    try {
        const data = yield call(Api.fetchDashboard);
        yield put(actions.loadDashboardData(data));
    }
    catch (e) {
    }
}

export function* dashboardFlow() {
    yield takeEvery(types.FETCH_DASHBOARD, fetchDashboard);
    yield takeLatest(types.TOGGLE_BLOCK_ATTACKS, toggleBlockAttacks);
    yield takeLatest(types.LOG_OUT, logout);
}